import List_LocalSettings from "../../../core/gd-modules/tasks-view/list/manager/settings/local/local-settings"
import {myTasksViewOptionDictionary, MyTasksViewName} from "../@const"

// const debug = "MyTasksLocalSettings"
const debug = false

export default class MyTasksLocalSettings extends List_LocalSettings {

    public currentView!         : MyTasksViewName
    public currentViewId!       : ID
    public spaceId?             : ID = undefined
    public isSubmenuCompact     : boolean = false

    constructor() {
        super('my-tasks')

        const values            = this._readFromLocalStorage()

        this.currentView        = _.get(values, 'currentView', MyTasksViewName.ACTION_REQUIRED)
        this.currentViewId      = _.get(values, 'currentViewId', this.currentView ? this.currentView : MyTasksViewName.ACTION_REQUIRED)
        this.spaceId            = _.get(values, 'spaceId', undefined)
        this.isSubmenuCompact   = _.get(values, 'isSubmenuCompact', false)

        // if there is no such view (can be removed or renamed) then reset to MyTasksView.ACTION_REQUIRED
        if (!myTasksViewOptionDictionary[this.currentView]) {
            this.currentView = MyTasksViewName.ACTION_REQUIRED
        }
    }

    toggleIsSubmenuCompact() {
        this.isSubmenuCompact = !this.isSubmenuCompact
        this.save()
    }

    toObject() {
        return _.assign(super.toObject(), {
            currentView     : this.currentView,
            currentViewId   : this.currentViewId,
            spaceId         : this.spaceId,
            isSubmenuCompact: this.isSubmenuCompact
        })
    }
}
